import axios from "axios";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import parse from "html-react-parser";

const ViewUser = () => {
  const userId = useParams();
  const id = Object.values(userId);
  const Navigator = useNavigate();

  const [userData, setUserData] = useState({});

  const fetchuser = async () => {
    try {
      const response = await axios.get(`/user/view/${id}`);
      if (response.data.status === 200) {
        setUserData(response.data.user);
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchuser();
    console.log();
  }, []);

  return <div>{parse(userData.my_signature.html)}</div>;
};

export default ViewUser;
